
export class WorkflowCompleteForm {
    id?;
    workflowStepId?;
    code?;
    serviceCode?;
    isGeneral?;
}
